import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import RoleImpersonator from './RoleImpersonator';
import DiamondChatWidget from './DiamondChatWidget';
import { LayoutWrapper, MainContent } from './Layout.styles';
const Layout = ({ children }) => {
    const location = useLocation();
    // List of public pages that should NOT show the footer
    const publicPages = [
        '/',
        '/welcome',
        '/contact',
        '/login',
        '/privacy-policy',
        '/terms-of-service'
    ];
    const isPublicPage = publicPages.includes(location.pathname);
    return (_jsxs(LayoutWrapper, { children: [_jsx(Header, {}), _jsx(MainContent, { children: children }), !isPublicPage && _jsx(Footer, {}), _jsx(RoleImpersonator, {}), _jsx(DiamondChatWidget, {})] }));
};
export default Layout;
